import React from 'react';
import { Avatar, Box, Flex, Text } from '@chakra-ui/react';

interface RowIdentityProps {
  title: string;
  meta?: string;
  monoMeta?: boolean;
  image?: string;
}

export const RowIdentity = ({ title, meta, monoMeta = false, image }: RowIdentityProps) => (
  <Flex align="center" gap="10px" minW={0}>
    {image ? (
      <Avatar size="sm" w="24px" h="24px" borderRadius="6px" src={image} name="" />
    ) : (
      <Flex
        aria-hidden
        w="20px"
        h="20px"
        flexShrink={0}
        align="center"
        justify="center"
        borderRadius="6px"
        bg="rgba(41, 41, 41, 0.64)"
        color="white"
        fontSize="9px"
        fontWeight={500}
      >
        {title?.charAt(0)?.toUpperCase()}
      </Flex>
    )}
    <Box minW={0}>
      <Text fontSize="13px" lineHeight="16px" fontWeight={500} color="content.strong" noOfLines={1}>
        {title}
      </Text>
      {meta && (
        <Text
          fontFamily={monoMeta ? 'mono' : 'body'}
          fontSize="12px"
          lineHeight="14px"
          color="content.subtle"
          noOfLines={1}
        >
          {meta}
        </Text>
      )}
    </Box>
  </Flex>
);
